// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2Zcrf","modalForm":"UpgradeEpcsModal_modalForm__3QnRq","modalFooter":"UpgradeEpcsModal_modalFooter__3HF8A"};